import {ElementsConsumer} from '@stripe/react-stripe-js';
import {CheckoutForm} from './CheckoutForm';

export type InjectedCheckoutFormProps = {
  projectCode: string;
  product: string;
  amount: number;
  nftId?: string;
  onSuccess: Function;  
}
export const InjectedCheckoutForm = (props: InjectedCheckoutFormProps) => (
  <ElementsConsumer>
    {({stripe, elements}) => (
      <CheckoutForm
        projectCode={props.projectCode}
        product={props.product}
        stripe={stripe}
        elements={elements}
        amount={props.amount}
        nftId={props.nftId}
        onSuccess={props.onSuccess}
      />
    )}
  </ElementsConsumer>
);